import { Component, OnInit } from '@angular/core';
import { LibroService } from 'src/app/servicios/libro.service';

@Component({
  selector: 'app-nuevo-libro',
  templateUrl: './nuevo-libro.component.html',
  styleUrls: ['./nuevo-libro.component.scss']
})
export class NuevoLibroComponent implements OnInit {

  public titulo:string;
  public url:string;

  constructor(private libroSvc:LibroService) { }

  ngOnInit(): void {
  }

  subirLibro()
  {
    let libro = {
      titulo:this.titulo,
      url:this.url
    }
    this.libroSvc.saveCurso(libro).finally(()=>
    {
      this.titulo = ""
      this.url = ""
    });
  }
}
